module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.25803",
      "ably": "static-2.2",
      "conversations-async-data": "static-2.6422",
      "conversations-error-reporting": "static-1.7698",
      "conversations-internal-pub-sub": "static-1.14758",
      "conversations-internal-schema": "static-1.11405",
      "conversations-message-history": "static-1.9850",
      "conversations-test-sdk": "static-1.9236",
      "conversations-visitor-experience-components": "static-1.19166",
      "head-dlb": "static-1.3911",
      "hs-promise-utils": "static-1.4280",
      "hs-test-utils": "static-1.6748",
      "hubspot-dlb": "static-2.1406",
      "HubStyleTokens": "static-2.10248",
      "I18n": "static-7.1385",
      "jasmine-immutable": "static-1.1717",
      "jasmine-runner": "static-1.5161",
      "quartz": "static-1.5509",
      "react-aria": "static-1.38",
      "react-dlb": "static-1.52",
      "react-transition-group": "static-2.8",
      "redux-thunk": "static-2.43",
      "transmute": "static-2.29",
      "urlinator": "static-1.3303",
      "viral-links-lib": "static-1.5632",
      "visitor-ui-component-library": "static-1.4941",
      "webpack-env": "static-1.54",
      "ably-hubspot-js": "static-2.3330",
      "atom": "static-1.3970",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.3554",
      "conversations-infrastructure": "static-1.7685",
      "conversations-prop-types": "static-1.6175",
      "conversations-visibility-tools": "static-1.4505",
      "conversations-visitor-message-history": "static-1.17903",
      "cssUtils": "static-1.483",
      "enviro": "static-4.300",
      "flux-actions": "static-1.270",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.4807",
      "hubspot-url-utils": "static-1.3063",
      "immer": "static-1.33",
      "immutable": "static-2.19",
      "metrics-js": "static-1.8459",
      "PatternValidationJS": "static-1.437",
      "PortalIdParser": "static-2.278",
      "raven": "static-3.4646",
      "react": "static-7.151",
      "react-dom": "static-7.85",
      "react-redux": "static-7.16",
      "react-rhumb": "static-1.15337",
      "react-select-plus": "static-1.65",
      "react-utils": "static-2.4280",
      "redux": "static-4.16",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize": "static-1.3136",
      "sanitize-text": "static-1.6930",
      "signup-constants": "static-1.16139",
      "styled-components": "static-2.64",
      "StyleGuideUI": "static-3.458",
      "usage-tracker": "static-1.6215",
      "usage-tracker-core": "static-1.6065",
      "usage-tracker-multi": "static-1.4629",
      "usage-tracker-public": "static-1.6026",
      "visitor-ui-component-library-icons": "static-1.4752",
      "hs-promise-rejection-tracking": "static-1.4190",
      "raven-hubspot": "static-1.4953",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.2407",
      "moment": "static-3.26",
      "quartz-core": "static-1.4728",
      "react-immutable-proptypes": "static-2.8",
      "foundations-assets": "static-1.3673",
      "foundations-components": "static-1.5943",
      "foundations-theming": "static-1.3070",
      "UIComponents": "static-3.7196",
      "conversations-skeleton-state": "static-1.6137",
      "cv-backend-services": "static-1.1129",
      "icons": "static-2.591",
      "react-input-autosize": "static-2.17",
      "ui-images": "static-2.817",
      "permission-components": "static-1.4111",
      "react-virtualized": "static-2.73",
      "HeadJS": "static-2.572",
      "framer-motion": "static-1.40",
      "hs-test-utils-bend-plugin": "static-1.1859",
      "msw": "static-1.39",
      "testing-library": "static-1.120",
      "i18n-data": "static-1.197",
      "moment-timezone": "static-5.51",
      "jasmine": "static-4.3092",
      "quartz-core-utils": "static-1.2376",
      "signup-ui-url-generator": "static-2.6806",
      "HubStyle": "static-2.10557",
      "sassPrefix": "static-1.130",
      "csstype": "static-1.38",
      "history": "static-4.47",
      "usage-tracker-anonymous": "static-1.4632",
      "copilot-toolkit": "static-1.6124",
      "dispatcher": "static-1.112",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.643",
      "hub-http-shared-msw-handlers": "static-1.6997",
      "hubspotter-http": "static-1.3542",
      "hubspotter-http-shared-msw-handlers": "static-1.6995",
      "mobile-manifest-mixins": "static-1.343",
      "platform-navigation-bootstrap": "static-1.11163",
      "quick-fetch": "static-1.2772",
      "react-router-dom": "static-5.26",
      "ui-fonts": "static-1.331",
      "hs-story-utils": "static-1.8146",
      "bend-plugin-foundations-components": "static-1.2211",
      "floating-ui": "static-1.28",
      "foundations-theming-specialty": "static-1.787",
      "tanstack-table": "static-1.23",
      "bend-plugin-foundations-theming": "static-1.1553",
      "foundations-theming-base": "static-1.2055",
      "rpc-client-utils": "static-1.3468",
      "ts-schema": "static-1.3089",
      "chatspot-client-types": "static-1.8506",
      "chatspot-core": "static-1.15334",
      "platform-infra-nav-components": "static-1.6650"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.25803",
      "ably": "/ably/static-2.2",
      "conversations-async-data": "/conversations-async-data/static-2.6422",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.7698",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.14758",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.11405",
      "conversations-message-history": "/conversations-message-history/static-1.9850",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.9236",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.19166",
      "head-dlb": "/head-dlb/static-1.3911",
      "hs-promise-utils": "/hs-promise-utils/static-1.4280",
      "hs-test-utils": "/hs-test-utils/static-1.6748",
      "hubspot-dlb": "/hubspot-dlb/static-2.1406",
      "HubStyleTokens": "/HubStyleTokens/static-2.10248",
      "I18n": "/I18n/static-7.1385",
      "jasmine-immutable": "/jasmine-immutable/static-1.1717",
      "jasmine-runner": "/jasmine-runner/static-1.5161",
      "quartz": "/quartz/static-1.5509",
      "react-aria": "/react-aria/static-1.38",
      "react-dlb": "/react-dlb/static-1.52",
      "react-transition-group": "/react-transition-group/static-2.8",
      "redux-thunk": "/redux-thunk/static-2.43",
      "transmute": "/transmute/static-2.29",
      "urlinator": "/urlinator/static-1.3303",
      "viral-links-lib": "/viral-links-lib/static-1.5632",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.4941",
      "webpack-env": "/webpack-env/static-1.54",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.3330",
      "atom": "/atom/static-1.3970",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.3554",
      "conversations-infrastructure": "/conversations-infrastructure/static-1.7685",
      "conversations-prop-types": "/conversations-prop-types/static-1.6175",
      "conversations-visibility-tools": "/conversations-visibility-tools/static-1.4505",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.17903",
      "cssUtils": "/cssUtils/static-1.483",
      "enviro": "/enviro/static-4.300",
      "flux-actions": "/flux-actions/static-1.270",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.4807",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3063",
      "immer": "/immer/static-1.33",
      "immutable": "/immutable/static-2.19",
      "metrics-js": "/metrics-js/static-1.8459",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "PortalIdParser": "/PortalIdParser/static-2.278",
      "raven": "/raven/static-3.4646",
      "react": "/react/static-7.151",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.16",
      "react-rhumb": "/react-rhumb/static-1.15337",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-utils": "/react-utils/static-2.4280",
      "redux": "/redux/static-4.16",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize": "/sanitize/static-1.3136",
      "sanitize-text": "/sanitize-text/static-1.6930",
      "signup-constants": "/signup-constants/static-1.16139",
      "styled-components": "/styled-components/static-2.64",
      "StyleGuideUI": "/StyleGuideUI/static-3.458",
      "usage-tracker": "/usage-tracker/static-1.6215",
      "usage-tracker-core": "/usage-tracker-core/static-1.6065",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.4629",
      "usage-tracker-public": "/usage-tracker-public/static-1.6026",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.4752",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4190",
      "raven-hubspot": "/raven-hubspot/static-1.4953",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2407",
      "moment": "/moment/static-3.26",
      "quartz-core": "/quartz-core/static-1.4728",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "foundations-assets": "/foundations-assets/static-1.3673",
      "foundations-components": "/foundations-components/static-1.5943",
      "foundations-theming": "/foundations-theming/static-1.3070",
      "UIComponents": "/UIComponents/static-3.7196",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6137",
      "cv-backend-services": "/cv-backend-services/static-1.1129",
      "icons": "/icons/static-2.591",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "ui-images": "/ui-images/static-2.817",
      "permission-components": "/permission-components/static-1.4111",
      "react-virtualized": "/react-virtualized/static-2.73",
      "HeadJS": "/HeadJS/static-2.572",
      "framer-motion": "/framer-motion/static-1.40",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.1859",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.120",
      "i18n-data": "/i18n-data/static-1.197",
      "moment-timezone": "/moment-timezone/static-5.51",
      "jasmine": "/jasmine/static-4.3092",
      "quartz-core-utils": "/quartz-core-utils/static-1.2376",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.6806",
      "HubStyle": "/HubStyle/static-2.10557",
      "sassPrefix": "/sassPrefix/static-1.130",
      "csstype": "/csstype/static-1.38",
      "history": "/history/static-4.47",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.4632",
      "copilot-toolkit": "/copilot-toolkit/static-1.6124",
      "dispatcher": "/dispatcher/static-1.112",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.643",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.6997",
      "hubspotter-http": "/hubspotter-http/static-1.3542",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.6995",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.343",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11163",
      "quick-fetch": "/quick-fetch/static-1.2772",
      "react-router-dom": "/react-router-dom/static-5.26",
      "ui-fonts": "/ui-fonts/static-1.331",
      "hs-story-utils": "/hs-story-utils/static-1.8146",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.2211",
      "floating-ui": "/floating-ui/static-1.28",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.787",
      "tanstack-table": "/tanstack-table/static-1.23",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.1553",
      "foundations-theming-base": "/foundations-theming-base/static-1.2055",
      "rpc-client-utils": "/rpc-client-utils/static-1.3468",
      "ts-schema": "/ts-schema/static-1.3089",
      "chatspot-client-types": "/chatspot-client-types/static-1.8506",
      "chatspot-core": "/chatspot-core/static-1.15334",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.6650"
    },
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};